import { render, staticRenderFns } from "./RemManagement.vue?vue&type=template&id=4adfea76&scoped=true&"
import script from "./RemManagement.vue?vue&type=script&lang=js&"
export * from "./RemManagement.vue?vue&type=script&lang=js&"
import style0 from "./RemManagement.vue?vue&type=style&index=0&id=4adfea76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4adfea76",
  null
  
)

export default component.exports